import Vue from 'vue'
import accounting from 'accounting'
import { isNumber } from 'lodash'

Vue.filter('money', value => {
  if (!isNumber(value)) {
    return value
  }

  return accounting.formatMoney(value)
})



// WEBPACK FOOTER //
// ./src/utils/filters.js